const styles = {
  container: (responsive) => ({
    display: 'flex',
    backgroundColor: '#fff',
    padding: '0.75rem',
    borderRadius: '1rem',
    flexDirection: 'column',
    flexWrap: responsive ? 'wrap' : 'nowrap',
    alignContent: 'flex-start',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxShadow: '0px 4px 12px rgba(10, 16, 68, 0.08)',
  }),
  rowContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '0.5rem',
    width: '100%',
    flexWrap: 'nowrap',
  },
  rowFooterContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '0.5rem',
    width: '100%',
    flexWrap: 'nowrap',
    pt: 1,
  },
  button: {
    button: {
      padding: '0.5rem',
      fontSize: '14px',
      fontWeight: '400',
      color: 'gray.90',
      maxWidth: '200px',
      borderColor: ({ palette }) => palette.gray[90],
    },
    text: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    icon: (isSelected) => ({
      color: ({ palette }) => isSelected && palette.primary.main,
    }),
  },
  containerResponsive: (responsive) => ({
    display: 'flex',
    flexDirection: responsive ? 'column' : 'row',
    gap: '0.5rem',
    flexWrap: responsive ? 'wrap' : 'nowrap',
    flex: 1,
    width: '100%',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
  }),
  rightButton: { flexShrink: 0, display: 'flex', alignSelf: 'flex-start' },
  rightButtonBanner: {
    flexShrink: 0,
    display: 'flex',
    alignSelf: 'flex-start',
    lineHeight: 'normal',
    '.MuiButton-text': {
      pt: 0,
      pb: 0,
    },
  },
};

export default styles;
